// extracted by mini-css-extract-plugin
export default {"cls1":"cayM0uS_TGu9oRoI3192","cls2":"hSw_71CBGNnuTDVlR19Y cayM0uS_TGu9oRoI3192"};